<app-mrp-scrolltop></app-mrp-scrolltop>


<!-- Main -->
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">

      <div class="row">
        <div class="col-12-large">

          <div>
            <img src="assets/images/precinct/underoaksdrawing.jpg" alt="Under the Oaks Drawing" class="hero-header-img">
          </div>

          <div class="right-menu">
            <mat-form-field appearance="fill">
              <mat-label>Tools...</mat-label>
              <mat-select (selectionChange)="onRouteSelect($event.value)">
                @for (routeOption of delegateroutes; track routeOption) {
                <mat-option [value]="routeOption.path">
                  {{ routeOption.label }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <h4><b>The Republican Party</b></h4>
          <p>The Republican Party of the United States was founded in Jackson, Michigan in 1854.
          </p>
          <p>The Republican National Committee, known as the RNC, provides the national leadership for the Republican
            Party across the states.
            It is the responsibility of the RNC to develop and promote the Republican Party Platform through organizing
            and operating fundraising and election strategy at the annual national convention.
          </p>
          <p>The RNC has 168 members which consists of the National Chair and a National Committeeman and National
            Committeewoman from each state of the fifty states and six territories.
            Each RNC committee member receives one vote at RNC meetings and votes to elect the RNC Chair.
          </p>
          <p>The <a href="assets/pdf/RNCPlatform-2020.pdf">Republican Party Platform</a> is the document that unites the
            party with the moral ideas worth fighting for.
          </p>

        </div>

        <div class="col-12-large ">

          <h5><b>The Nation Republican Party</b></h5>

          <p>The RNC has 168 members which consists of the National Chair and a National Committeeman and National
            Committeewoman from each state of the fifty states and six territories.
            Each RNC committee member receives one vote at RNC meetings and votes to elect the RNC Chair.
          </p>
          <p>The <a href="assets/pdf/RNCPlatform-2020.pdf">Republican Party Platform</a> is the document that unites the
            party with the moral ideas worth fighting for.
          </p>
        </div>

        <!-- <button mat-flat-button [matMenuTriggerFor]="menu">
    <span>{{ selectedPageText }}</span>
    <mat-icon>arrow_drop_down</mat-icon>
  </button>

  <mat-menu #menu="matMenu">
    <a mat-menu-item routerLink="/home" (click)="onPageSelected('stateparty')">
      <span>State Party</span>
    </a>
    <a mat-menu-item routerLink="/home" (click)="onPageSelected('delegate')">
      <span>Delegates</span>
    </a>
    <a mat-menu-item routerLink="/countyconvention" (click)="onPageSelected('countyconvention')">
      <span>County Convention</span>
    </a>
    <a mat-menu-item routerLink="/countyconvention" (click)="onPageSelected('timeline')">
      <span>TimeLine</span>
    </a>
    <a mat-menu-item routerLink="/countyconvention" (click)="onPageSelected('tools')">
      <span>Tools</span>
    </a>
    <a mat-menu-item routerLink="/documents" (click)="onPageSelected('documents')">
      <span>Documents</span>
    </a>
  </mat-menu> -->

      </div>
    </div>
  </div>
</section>

<!-- section 2 -->
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">

      <div class="row">
        <div class="col-12-large">

          <h5 class=""><b>Michigan Republican Party Structure</b></h5>

          <p>The Michigan Republican Party, also know as MIGOP, is lead by an elected leadership called the State
            Committee.
            Leadership is further divided into thirteen Congressional District Committees and eighty three County
            Executive Committees.
          </p>
          <p>These 3 blocks build, from the bottom up, County, District, State Party, a political system which models
            our national system, which is a constitutional republic.
          </p>
          <p>This flowchart diagrams the party process.</p>
          <p>
            <img src="assets/images/precinct/mrpflowchart.png" (click)="openFlowChartDialog()"
              class="img-fluid full-width" alt="historicmarker">
          </p>

          <div id="zoomButton" class="flowchart-button">
            <p><button mat-raised-button (click)="openFlowChartDialog()" class="mt-2">Zoom In</button></p>
          </div>

        </div>


        <div class="col-12-large ">

          <h5 class=""><b>Governance</b></h5>

          <p>The Michigan Republican Party is governed by a set of <a href=""><b>BYLAWS</b></a> that prescribe how the
            State Committee, District Committees, and County Committees work together.
            Each district and county also have their own set of independent governing bylaws.
          </p>

          <blockquote>
            <p>"The advancement and diffusion of knowledge is the only guardian of true liberty."- James Madison</p>
          </blockquote>


        </div>

      </div>
    </div>
  </div>
</section>


<!-- section 3 - History Section -->
<section id="main" class="wrapper">
  <div id="history-section" class="inner">
    <div class="content">

      <!-- History Grid Container -->
      <div id="history" class="history-grid">

        <!-- Row 1: Republican Party History + Historic Meeting Image -->
        <div class="history-text">
          <h5><b>Republican Party History</b></h5>
          <p>On July 6, 1854, over 1,000 people gathered in a Jackson hall to protest a recent expansion of slavery.
            The hall's cramped conditions and poor ventilation led them to move the meeting to a nearby park.
            It was here, under the shade of ancient oaks, that a group of party candidates was designated.
            That group of abolitionists were the beginning of the Republican party.
          </p>
        </div>

        <div id="historicmeeting" class="history-image">
          <img src="assets/images/history/historicmeeting.png" class="img-fluid" alt="Historic Meeting Under the Oaks">
        </div>

        <!-- Row 2: Michigan Republicans Moral Leaders + Marker 1 -->
        <div id="history-leaders" class="history-text">
          <h5><b>Michigan, Republicans, Moral Leaders</b></h5>
          <p>The conversations held on that quiet street corner set the stage for the Civil War and the eventual
            abolition of slavery. Michigan Republicans stood at the forefront of the abolitionist movement,
            championing human dignity and freedom for all.</p>
        </div>

        <div id="history-marker1" class="history-image">
          <img src="assets/images/history/marker1910.png" class="img-fluid" alt="Historic Marker 1910">
        </div>

        <!-- Row 3: History Leaders 2 + Marker 2 -->
        <div id="history-leaders2" class="history-text">
          <h5><b>Legacy of Leadership</b></h5>
          <p>Early Republican leadership in the United States emerged in the mid-1800s with figures such as Abraham
            Lincoln, Salmon P. Chase, and Thaddeus Stevens. The Republican Party was founded on the idea of preventing
            the expansion of slavery into new territories and promoting free labor. These leaders believed that a nation
            built on opportunity, hard work, and equal access to land would strengthen democracy and reduce the power of
            the slave system.</p>
        </div>

        <div id="history-marker2" class="history-image">
          <img src="assets/images/history/historicmarker.png" class="img-fluid" alt="Historic Marker">
        </div>

        <!-- Row 4: History Leaders 3 + Marker 3 -->
        <div id="history-leaders3" class="history-text">
          <h5><b>The Fight for Freedom</b></h5>
          <p>Republican leaders played a major role in expanding freedom by opposing slavery and pushing for legal
            reforms. They supported laws such as the Homestead Act, which gave free land to settlers, allowing more
            Americans to become independent farmers. Republicans also backed the Emancipation Proclamation and later the
            13th Amendment, which permanently ended slavery in the United States.</p>
        </div>

        <div id="history-marker4" class="history-text">
          <h5><b>The Civil War</b></h5>
          <p>The Civil War (1861-1865) was fought largely over the issue of slavery and the future of the Union. Under
            Republican leadership, President Abraham Lincoln worked to preserve the nation while transforming the war
            into a fight for human freedom. The Union’s victory not only kept the country united but also led to the
            abolition of slavery, reshaping the United States politically, socially, and morally.</p>

          <img src="assets/images/history/civilwar.png" class="img-fluid" alt="Civil War Leadership">
        </div>

        <!-- Quote Section - Full Width -->
        <div class="history-quote">
          <blockquote>
            <p>"When annual elections end, there slavery begins."<br>
              -John Adams, Thoughts on Government, 1776</p>
          </blockquote>
        </div>

      </div>

    </div>
  </div>
</section>


<!-- section 4 -->
<!-- <section id="main" class="wrapper">
      <div class="inner">
        <div class="content">

          <div class="row">
            <div class="col-6 col-12-large">


            </div>

            <div class="col-6 col-12-large ">


            </div>

          </div>
        </div>
      </div>
    </section> -->


<!---------------------END OF PAGE ---------------------------------------------------------------->